import { render } from "./BuilderLogo.vue?vue&type=template&id=9f0dd67e&scoped=true&ts=true&lang=pug"
import script from "./BuilderLogo.vue?vue&type=script&lang=ts&setup=true"
export * from "./BuilderLogo.vue?vue&type=script&lang=ts&setup=true"

import "./BuilderLogo.vue?vue&type=style&index=0&id=9f0dd67e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f0dd67e"]])

export default __exports__